import { useCallback, useEffect, useState } from "react";
import { MeFlightAlertItem, MeFlightAlertsService } from "../../../api/meFlightAlerts.service";
import { getDashErrorCode } from "./apiError.helper";

export interface UseMyFlightAlertsResult {
  data: MeFlightAlertItem[] | null;
  isLoading: boolean;
  isError: boolean;
  /** AU_001/AU_002/AU_003 -- no live session, distinct from a generic load failure. */
  isAuthError: boolean;
  refetch: () => void;
}

const AUTH_ERROR_CODES = new Set(["AU_001", "AU_002", "AU_003"]);

export const useMyFlightAlerts = (): UseMyFlightAlertsResult => {
  const [data, setData] = useState<MeFlightAlertItem[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isAuthError, setIsAuthError] = useState(false);

  const fetchAlerts = useCallback(() => {
    setIsLoading(true);
    setIsError(false);
    setIsAuthError(false);

    const service = new MeFlightAlertsService();
    service
      .getMyFlightAlerts()
      .then(setData)
      .catch((err) => {
        const errorCode = getDashErrorCode(err);
        if (errorCode && AUTH_ERROR_CODES.has(errorCode)) {
          setIsAuthError(true);
        } else {
          setIsError(true);
        }
        console.error("Failed to load flight alerts", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchAlerts();
  }, [fetchAlerts]);

  return { data, isLoading, isError, isAuthError, refetch: fetchAlerts };
};
